import {ActivatedRoute} from '@angular/router';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import * as moment from 'moment';

export function URL() {
    let url;
    switch (location.host) {
        case 'localhost:4200':
            url = 'http://10.68.101.215:8083/';
            break;
        case 'nti.admin':
            url = 'http://localhost:8083/';
            break;
        case 'test-erp.nti.hk':
            url = 'http://test-erp.nti.hk:9001/';
            break;
        case 'erp.nti.hk':
            url = 'https://erp.nti.hk:9001/';
            break;
        case 'cnerp.nti.hk':
            url = 'http://cnerp.nti.hk:9001/';
            break;
        case 'test-erp.ntichina.cn':
            url = 'https://test-erp.ntichina.cn:9001/';
            break;
        default:
            url = 'http://localhost:9001/';
            break;
    }
    return url;
}

export const NAMED_OUTLETS = false;
export const DEVELOPER_MODE = false;

export const DT_PARAMETERS: DataTables.Settings = {
    dom: '<"card o-hidden ngx-datatable material"<"table-responsive"rt<"datatable-footer"<"datatable-footer-inner"<"page-count"i><"datatable-pager"p>>>>>',
    pagingType: 'full_numbers',
    pageLength: 25,
    serverSide: true,
    responsive: true,
    processing: false,
    columnDefs: [
        {
            targets: 'nosort',
            orderable: false
        },
        {
            className: 'ngx-dataTable-header',
            targets: '_all'
        }
    ],
    destroy: true
};

export function getSelectedValue(array: Array<any>) {
    const newOption = [];
    $.each(array, (index: number, val: any) => {
        newOption.push(Number(val.id));
    });
    return newOption.join();
}

export function getDateObject(date: any = '') {
    const object = {day: null, month: null, year: null};
    let newDate;
    if (date != '') {
        newDate = moment(date).toObject();
    } else {
        newDate = moment().toObject();
    }
    object.day = Number(moment().month(newDate.date).format('MM'));
    object.month = Number(moment().month(newDate.months).format('MM'));
    object.year = newDate.years;
    return object;
}

export const routerOutlet = {
    'dashboard': 'primary',
    'product-configuration': NAMED_OUTLETS ? 'product-configuration' : 'primary',
    'hrms': NAMED_OUTLETS ? 'hrms' : 'primary',
    'vending-machine': NAMED_OUTLETS ? 'vending-machine' : 'primary',
    'customer': NAMED_OUTLETS ? 'customer' : 'primary',
    'authority-management': NAMED_OUTLETS ? 'authority-management' : 'primary',
    'account-management': NAMED_OUTLETS ? 'account-management' : 'primary',
    'franchise-management': NAMED_OUTLETS ? 'franchise-management' : 'primary',
    'report': NAMED_OUTLETS ? 'report' : 'primary',
};

export function getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc: any, key: any) => {
        const control = form.get(key);
        const errors = (control instanceof FormGroup || control instanceof FormArray)
            ? getAllErrors(control)
            : control.errors;
        if (errors) {
            acc[key] = errors;
            hasError = true;

            if (control instanceof FormControl) {
                control.markAsDirty();
            }
        }
        return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
}

export function getCancelRoute(activatedRoute: ActivatedRoute) {
    const url = '/' + activatedRoute.parent.snapshot.url.map((segment: any) => segment.path).join('/');
    const urlArray = url.replace('/', '').split('/');
    return [
        activatedRoute.parent.outlet == 'primary' ? '/' + activatedRoute.parent.parent.snapshot.url.map((segment: any) => segment.path)[0] : '/' + activatedRoute.parent.outlet,
        {
            outlets: {[activatedRoute.parent.outlet]: urlArray[urlArray.length - 1]}
        }
    ];
}
